import { blue50, blue50opacity50 } from '../../../colors/blue';
import { rem } from '../../../utils/rem';
export var MuiButtonGroup = {
    defaultProps: {
        disableRipple: true,
        disableElevation: true,
        variant: 'outlined',
        color: 'primary',
    },
    styleOverrides: {
        outlined: {
            '& [class*=MuiButton-containedPrimary]': {
                backgroundColor: 'transparent',
                border: "".concat(rem(1), " solid ").concat(blue50opacity50),
                color: blue50,
                minWidth: rem(36),
                paddingBlock: rem(5),
                paddingInline: rem(15),
                '&:hover': {
                    background: 'rgba(16, 110, 204, 0.04)',
                    border: "".concat(rem(1), " solid ").concat(blue50),
                    color: blue50,
                },
            },
        },
    },
};
